import { Grid, List } from "react-feather";
import { useAppDispatch } from "../../../ReduxToolkit/Hooks";
import { setGridView } from "../../../ReduxToolkit/Reducers/BookmarkTabSlice";
import { Href } from "../../../Constants/Constants";
import { LI, UL } from "../../../AbstractElements";
import { Link } from "react-router-dom";

const ViewBookmark = () => {
  const dispatch = useAppDispatch();
  return (
    <UL className="simple-list flex-row">
      <LI>
        <Link className="grid-bookmark-view" to={Href}>
          <Grid onClick={() => dispatch(setGridView(true))} />
        </Link>
      </LI>
      <LI>
        <Link className="list-layout-view" to={Href}>
          <List onClick={() => dispatch(setGridView(false))} />
        </Link>
      </LI>
    </UL>
  );
};
export default ViewBookmark;
